import Triggerable from "./Triggerable";
import Modal from "./Modal";

export default Triggerable(Modal);
